export default __webpack_public_path__ + "static/image/group.11e08de9.jpg";